module.exports = "/_next/static/images/og-image-velieve-min-73f738b23b89504aae69d6c508c958e3.jpg";